import React, { memo, useEffect, useMemo, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import { Toast } from 'primereact/toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChartBar, faChartColumn, faChartLine, faCircle, faCircleDot, faCoffee, faSort, faDatabase } from '@fortawesome/pro-solid-svg-icons'
import { faArrowDown, faStar, faArrowUp, faGear, faArrowRotateRight, faSquareChevronRight, faPlus, faPencil, faSquareCheck, faGripDotsVertical, faRectangleXmark } from '@fortawesome/pro-solid-svg-icons'
import './dataTable.scss'
import { Image } from 'react-bootstrap';
import excel from '../../assets/img/excel.png'
import WatchlistAddModal from '../watchlistComponents/watchlistAddModal';
import Week52Range from '../52WeekRange/52WeekRange';
import NumberFormatter from '../../formatters/NumberFormatter';
import { useNavigate } from "react-router-dom";
import ScoreFields from '../score/scoreFields';
import { InputText } from 'primereact/inputtext';
import { FilterMatchMode, FilterOperator, SortOrder } from 'primereact/api';
import { faCircleInfo, faSortDown, faSortUp } from '@fortawesome/pro-duotone-svg-icons';
import { useDispatch } from "react-redux";
import { setSelectedSecurity } from "../../stores/security";
import DropdownPicker from '../pickers/dropdownPicker';
import moment from 'moment';
import 'moment/locale/tr'; // Türkçe desteği aktif et
import { generateGUID, score2color } from '../../helpers/utils';
import { ChangeBody, DailyChangeBody, DynamicBody } from './columns';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import lodash from 'lodash';
import { useTranslation } from "react-i18next";
import { FilterService } from 'primereact/api';
import { Tooltip } from 'primereact/tooltip';
import ConsensusResearchComponent from '../standouts-table-colored-view/consensusResearch/consResearchBodyTemplateComponent';
import TechnicalAnalysisColoredBodyComponent from './../standouts-table-colored-view/technicalAnalysis/TechnicalAnalysisColoredBodyComponent';
import { useToast } from '../../context/toast-context';
import { de } from 'date-fns/locale';
// import ReactTooltip from 'react-tooltip';
const toLowerCaseTurkish = (str) => {
    const letters = { 'I': 'i', 'İ': 'i', };
    str = str.replace(/([İI])/g, letter => letters[letter]);
    return str.toLowerCase();
};

const customFilter = (value, filter) => {
    if (!filter) {
        return true;
    }
    if (!value) {
        return false;
    }
    return toLowerCaseTurkish(value.toString()).includes(toLowerCaseTurkish(filter));
};

FilterService.register('customContains', customFilter);

const accounting = require('accounting-js');
const DataTableComponent = (props) => { // props: {columnsProp, dataProp, columnsSelect,search,absoluteSearch, excelExport, excelExportName, emptyMessage, scrollHeight, restartColumns,removeSymbolOnWatchlist,sortOrder, sortField } 
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isHoveredDividendYieldInfo, setIsHoveredDividendYieldInfo] = useState(false);
    const { t } = useTranslation();
    const numberFormatter = new NumberFormatter();

    const [tableData, setTableData] = useState([]);

    const [visibleColumnSelect, setVisibleColumnSelect] = useState(false);

    const [visibleSearch, setVisibleSearch] = useState(false);

    const [enabledColumnSelectButton, setEnabledColumnSelectButton] = useState(true);

    const [count, setCount] = useState(0);

    const [columns, setColumns] = useState([]);

    const [visibleColumns, setVisibleColumns] = useState([]);

    const [selectedItem, setSelectedItem] = useState(null);

    const [visibleAbsoluteSearch, setVisibleAbsoluteSearch] = useState(false);

    const [filters, setFilters] = useState({
        global: { value: null, matchMode: 'customContains' },
        'dividendCalendarPaymentDate': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        'paymentDate': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        name: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: 'customContains' }] },
        tickerName: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: 'customContains' }] },
        code: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: 'customContains' }] }

    });

    const onGlobalFilterChange = (event) => {
        const value = event.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;
        setFilters(_filters);
    };

    // const toast = useRef(null);
    const toast = useToast();
    const op = useRef(null);

    useMemo(() => {
        if (props.columnsProp.length > 0) {
            const sortedColumns = [...props.columnsProp].sort((a, b) => a.order - b.order); // Sort by 'order' property
            setColumns(sortedColumns);
            setEnabledColumnSelectButton(props.columnsSelect);
            setVisibleSearch(props.search);
            setVisibleColumns(sortedColumns.filter(col => col.isVisible === true));
            setCount(sortedColumns.filter(col => col.isVisible === true).length);
            setVisibleAbsoluteSearch(props.absoluteSearch);
            console.log(columns);
            console.log(sortedColumns);
            console.log(tableData);
        }
    }, [props.columnsProp])

    useMemo(() => {
        if (!lodash.isEqual(props.dataProp, tableData)) {
            setTableData(props.dataProp);
        }
    }, [props.dataProp]);


    // useEffect(() => {
    //     if (props.dataProp.length > 0 && props.columnsProp.length > 0) {
    //         setTableData(props.dataProp);
    //     }
    // }, [props.dataProp])

    // useEffect(() => {
    //     if (props.customSearch != undefined)
    //         onGlobalFilterChangePublic(props.customSearch);
    // }, [props.customSearch])

    // useEffect(() => {
    //     console.log('props.sortField: ', props.sortField);
    // }, [props.sortField])


    //#region BODY TEMPLATE
    const isfavClick = (data) => {
        try {
            // console.log('isfavClick: ', data);
            data.fav = !data.fav;
            tableData[0].fav = true
            setTableData(tableData);
        } catch (error) {
            // console.log('isfavClick error: ', error);
        }
    }

    const clickGoTechnicalAnalysisPage = (data) => {
        try {
            // Store selected security in localStorage and navigate without URL param
            const id = data.entityId !== undefined ? data.entityId : data.id;
            if (id !== undefined) {
                const selectedSecurity = {
                    id: id,
                    objectId: id,
                    code: data.UniqueCode || data.code,
                    name: data.name || data.symbolName
                };
                localStorage.setItem('selectedSecurity', JSON.stringify(selectedSecurity));
                toast.current.show({ severity: 'info', summary: t('dataTable.directedTechnicalAnalsis'), detail: t('pleaceWait'), life: 3000 });
                navigate("/technicalAnalysis");
            } else {
                toast.current.show({ severity: 'error', summary: t('dataTable.notEntityId'), detail: t('dataTable.directedTechnicalAnalsis'), life: 3000 });
            }
        } catch (error) {
            console.log('clickGoTechnicalAnalysisPage error: ', error);
        }
    }


    const favBodyTemplate = (data, template) => {
        const handleUpdateData = (updatedData) => {
            // Update the parent component state or perform other actions with the updated data
            data = updatedData  // Assuming setData is a state setter function in the parent component
        };
        if (template === 'favWatchlist') {
            return (
                <>
                    <FontAwesomeIcon icon={faStar} style={{ color: '#EDB618' }} onClick={(res) => props.removeSymbolOnWatchlist(data, res)} />
                </>
            )
        }
        else if (template === 'favModal') {
            return (
                <>
                    <WatchlistAddModal data={data} />

                </>
            )
        }
    };

    const tickerCodeBodyTemplate = (data) => {
        if (data.tickerCode) {
            return (
                <div className='roboto-bold-14 tickerCode'>{data.tickerCode} </div>
            )
        }
    };

    const tickerNameBodyTemplate = (data) => {
        return (
            <div className='roboto-medium-14 tickerName'>{data.tickerName} </div>
        )
    };

    const symbolNameBodyTemplate = (data) => {
        return (
            <div className='roboto-medium-14 tickerName' onClick={(event) => { goToSymbol(data, "symbolNameBodyTemplate") }}>{data.symbolName} </div>
        )
    };
    const nameBodyTemplate = (data, col) => {
        // console.log('nameBodyTemplate col: ', col);

        if (col.clikable == true) {

            if (col.elipsisName) {
                return (
                    <div className=' roboto-medium-14 elipsis-name' onClick={(event) => { goToSymbol(data, "nameBodyTemplate") }}>{data.name} </div>
                )
            }
            else {
                return (
                    <div className='roboto-medium-14' onClick={(event) => { goToSymbol(data, "nameBodyTemplate") }}>{data.name} </div>
                )
            }
        }
        else if (col.elipsisName) {
            return (
                <div className=' roboto-medium-14 elipsis-name'>{data.name} </div>
            )
        }
        else {
            return (
                <div className='roboto-medium-14'>{data.name} </div>
            )
        }

    };

    const codeBodyTemplate = (data, col) => {
        // console.log('codeBodyTemplate col: ', col);

        if (col.clikable == true) {
            return (
                <div className='roboto-medium-14 tickerCode' onClick={(event) => { goToSymbol(data, "codeBodyTemplate") }}>{data.code} </div>
            )
        }
        else {
            return (
                <div className='roboto-medium-14'>{data.code} </div>
            )
        }
    };

    const goToSymbol = (data, field) => {
        // console.log('data: ', data);



        if (field === "symbolNameBodyTemplate") {

            // dispatch(setSelectedSecurity(
            //     {
            //         "alternativeName": "",
            //         "code": "code.NaN",
            //         "Code": "code.NaN",
            //         "countryCode": "TR",
            //         "dataId": 14,
            //         "elite": false,
            //         "id": data['@'],
            //         "index": false,
            //         "listed": true,
            //         "name": data.symbolName,
            //         "objectId": data['@'],
            //         "screenable": true,
            //         "sourceId": 101,
            //         "uniqueCode": data.symbolName,
            //         "visible": true
            //     }
            // ));


            window.open(`/StockAnalysis/summary/${data.code || data.symbolCode}`, '_blank');
        }
        else if (field === "nameBodyTemplate") {
            // dispatch(setSelectedSecurity(
            //     {
            //         "alternativeName": "",
            //         "code": data.code,
            //         "Code": data.code,
            //         "countryCode": "TR",
            //         "dataId": 14,
            //         "elite": false,
            //         "id": data.entityId,
            //         "index": false,
            //         "listed": true,
            //         "name": data.name,
            //         "objectId": data.entityId,
            //         "screenable": true,
            //         "sourceId": 101,
            //         "uniqueCode": data.code,
            //         "visible": true
            //     }
            // ));
            window.open(`/StockAnalysis/summary/${data.code}`, '_blank');
        }
        else if (field === "codeBodyTemplate") {

            if (data.code.startsWith('BIST')) {
                window.open("/IndexAnalysis/", '_blank');
            }
            else {
                // dispatch(setSelectedSecurity(
                //     {
                //         "alternativeName": "",
                //         "code": data.code,
                //         "Code": data.code,
                //         "countryCode": "TR",
                //         "dataId": 14,

                //         "elite": false,
                //         "id": data.entityId,
                //         "index": false,
                //         "listed": true,
                //         "name": data.name,
                //         "objectId": data.entityId,
                //         "screenable": true,
                //         "sourceId": 101,
                //         "uniqueCode": data.code,
                //         "visible": true
                //     }
                // ));
                window.open(`/StockAnalysis/summary/${data.code}`, '_blank');
            }
        }
    }

    const dividendYieldBodyTemplate = (data) => {
        return (
            <div className='roboto-medium-14'>
                <label>
                    {numberFormatter.Double(data.dividendYield, 2)}
                </label>

            </div>
        )
    };

    const dividendYieldHeaderTemplate = (data, col) => {
        if (col.infoLabel) {
            return (
                <div className='roboto-medium-14 info-label-div' >
                    <label className='info-label-col-header'>
                        <span className='roboto-medium-18 m-r-5 header-content'>
                            <>
                                <FontAwesomeIcon
                                    className='info-icon'
                                    icon={faCircleInfo}
                                    data-pr-tooltip={t('dataTable.oneYearDividendYield')}
                                    data-pr-position="left"
                                    data-pr-at="right+5 top"
                                    data-pr-my="left center"
                                    tooltipOptions={{ position: 'mouse' }}
                                />
                                <Tooltip target=".info-icon" />
                            </>
                        </span>
                        <span className="header-text">{col.header}</span>
                    </label>
                </div>
            )
        }
        else {
            return (
                <div className='roboto-medium-14 datatable-header-container'>
                    <label className="header-text">
                        {col.header}
                    </label>
                </div>
            )
        }

    };



    const technicalAnalysisBodyTemplate = (data) => {

        return (
            <div className='roboto-medium-14 taBg'>
                <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => clickGoTechnicalAnalysisPage(data)} />
            </div>
        )
    };


    const dividendExpectChartBodyTemplate = (data) => {

        return (
            <div className='roboto-medium-14 taBg'>
                <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => props.openDividendGrapshModal(data)} />
            </div>
        )
    };

    // eslint-disable-next-line react/display-name
    const IndicatorsBodyTemplate = (data) => {
        if (!lodash.isEqual(data)) {
            // console.count('indicatorsBodyTemplate')

            if (data.indicators && data.indicators.length > 0) {
                if (data.indicators[0].currencyId) {

                    data.indicators = data.indicators.filter((item) => item.currencyId == 1);

                    return (
                        <div key={data.code}>
                            {/* <div>{generateGUID()}</div> */}
                            <ScoreFields data={data} />
                        </div>
                    )
                }
                else {
                    return (
                        <div key={data.code}>
                            {/* <div>{generateGUID()}</div> */}
                            <ScoreFields data={data} />
                        </div>
                    )
                }
            }

        }
        else {
            return null;
        }

    };
    // const IndicatorsBodyTemplate = (data) => {

    //     if (!lodash.isEqual(data.indicators)) {
    //         console.count('indicatorsBodyTemplate');
    //         // useMemo kullanarak, yalnızca data ya da data.indicators değiştiğinde filtrelemeyi çalıştır
    //         const filteredIndicators = React.useMemo(() => {
    //             return data.indicators.filter((item) => item.currencyId === 1);
    //         }, [data, data.indicators]);  // Bağımlılıkları belirtmek önemli, böylece yalnızca değişiklik olduğunda güncellenir.

    //         data.indicators = filteredIndicators;

    //         return (
    //             <div key={data.code}>
    //                 <ScoreFields data={data} />
    //             </div>
    //         );
    //     }

    //     return null;
    // };

    // const changeBodyTemplate = (data) => {
    //     return (
    //         <div className='changeBodyTemplate'>
    //             <Container >
    //                 <Row className='changeBodyTemplate'>
    //                     <Col md='6' sm='6' className='p-r-25 p-l-0 p-t-0 p-b-0 text-align-right'>
    //                         {data.change >= 0 ? <FontAwesomeIcon icon={faArrowUp} /> : <FontAwesomeIcon icon={faArrowDown} />}
    //                     </Col>
    //                     <Col md='6' sm='6' className='p-0'>
    //                         {data.change &&
    //                             <Row >
    //                                 % {data.change}
    //                             </Row>
    //                         }
    //                         {data.dailyChange &&
    //                             <Row >
    //                                 % {formatNumber(data.dailyChange)}
    //                             </Row>
    //                         }
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </div>
    //     )
    // };


    const changeBodyTemplate = (data) => {
        console.count('changeBodyTemplate')
        return <ChangeBody data={data} />
    };

    // const dailyChangeBodyTemplate = (data) => {
    //     console.count('dailyChangeBodyTemplate')
    //     return (
    //         <div className='changeBodyTemplate'>
    //             <Container >
    //                 <Row className='changeBodyTemplate'>
    //                     <Col md='6' sm='6' className='p-r-25 p-l-0 p-t-0 p-b-0 text-align-right'>
    //                         {data.dailyChangeColor == 'green' ? <FontAwesomeIcon icon={faArrowUp} />
    //                             : data.dailyChangeColor == 'red' ? < FontAwesomeIcon icon={faArrowDown} />
    //                                 : <FontAwesomeIcon className='realTimeCircleIcon' icon={faCircle} />
    //                         }
    //                     </Col>
    //                     <Col md='6' sm='6' className='p-0'>
    //                         <Row >
    //                             {data.dailyChange == 0 &&
    //                                 <label className='p-0'>
    //                                     {formatNumber(data.dailyChange)}
    //                                 </label>
    //                             }
    //                             {data.dailyChange !== 0 &&
    //                                 <label className='p-0'>
    //                                     % {formatNumber(data.dailyChange)}
    //                                 </label>
    //                             }
    //                         </Row>
    //                     </Col>
    //                 </Row>
    //             </Container>
    //         </div>
    //     )
    // };

    const dailyChangeBodyTemplate = (data) => {
        console.log('------ dailyChangeBodyTemplate', data.dailyChange)
        return <DailyChangeBody rawData={data} />
    };

    const rocChangeBodyTemplate = (data, period) => {
        let change;
        if (period == 'rocDaily') {
            change = data.rocDaily;
        }
        else if (period == 'rocWeekly') {
            change = data.rocWeekly;
        }
        else if (period == 'rocMonthly') {
            change = data.rocMonthly;
        }
        else if (period == 'rocYtd') {
            change = data.rocYtd;
        }
        else if (period == 'rocAnnualy') {
            change = data.rocAnnualy;
        }
        else if (period == 'rocAnnual') {
            change = data.rocAnnual;
        }
        else if (period == 'rocBetweenDate') {
            change = data.rocBetweenDate;
        }


        return (
            <div className='changeBodyTemplate'>

                <Container >
                    <Row className='changeBodyTemplate'>
                        {/* <Col md='6' sm='6' className='p-r-25 p-l-0 p-t-0 p-b-0 text-align-right'>

                        </Col> */}
                        <Col md='12' sm='12' className='p-0'>
                            <Row >
                                <div className='p-0'>
                                    {change > 0 ? <FontAwesomeIcon className='change-state-icon ' icon={faArrowUp} />
                                        : change < 0 ? <FontAwesomeIcon className='change-state-icon ' icon={faArrowDown} />
                                            : <FontAwesomeIcon className='change-state-icon realTimeCircleIcon' icon={faCircle} />
                                    }
                                    <label className='change-value'>
                                        % {numberFormatter.Double(change, 2)}
                                    </label>

                                </div>
                                {/* {change == 0 &&
                                    <label className='change-value'>
                                        %{change}
                                    </label>

                                }
                                {change !== 0 &&

                                    <div className='p-0'>
                                        {change > 0 ? <FontAwesomeIcon className='change-state-icon ' icon={faArrowUp} />
                                            : change < 0 ? <FontAwesomeIcon className='change-state-icon ' icon={faArrowDown} />
                                                : <FontAwesomeIcon className='change-state-icon realTimeCircleIcon' icon={faCircle} />
                                        }
                                        <label className='change-value'>
                                            % {change}
                                        </label>

                                    </div>
                                } */}
                            </Row>
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    };

    const week52BodyTemplate = (data) => {
        if (data) {
            return (
                <div className='changeBodyTemplate'>
                    <Container >
                        <Row className='changeBodyTemplate'>
                            <Col>
                                <Week52Range data={data} />
                            </Col>
                        </Row>
                    </Container>
                </div>

            )
        }
    };


    const symbolScore2Color = (score) => {
        if (score <= 200)
            return "#BA290C";
        else if (score > 200 && score <= 400)
            return "#9E9E9E";
        // else if (score > 400 && score <= 600)
        else if (score > 400)
            return "#158006";
        else
            return "";
    }


    const scoreBodyTemplate = (data) => {
        return (
            <div className='scoreBodyTemplate'>
                <Container>
                    <Row className='scoreBodyTemplate'>
                        <Col md='12' sm='12' className='p-0'>
                            <div
                                className={[`score-bg roboto-medium-14 ${data.score <= 200 ? 'red' : data.score > 200 && data.score <= 400 ? 'grey' : 'green'}  `]}
                            >
                                <label className='score-text'>
                                    {data.score}
                                </label>

                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        )

    };

    const headerBodyTemplate = (field) => {

        return (
            <div className="">
                {/* <Search /> */}
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText placeholder="Search" />
                </span>
            </div>
        )
    };

    // const numberBodyTemplate = (data, field) => {
    //     return (
    //         <Container className='numberBodyTemplateContainer'>
    //             <Row className='numberBodyTemplateRow'>
    //                 <Col md='12' sm='12' className='p-0'>
    //                     <label className='p-0 numberBodyTemplateLabel'>
    //                         {numberFormatter.Double(data[field], 2)}
    //                     </label>
    //                 </Col>
    //             </Row>
    //         </Container>
    //     )
    // };


    const numberBodyTemplate = (data, field) => {
        //console.count('numberBodyTemplate')
        return <DynamicBody data={data} field={field} />
    };


    const customFormatter = (rowData, field, format) => {
        // 1) Explicit text-like fields should be rendered as-is (no numeric formatting)
        //    This prevents cases like description strings being shown as 0.00
        if (field === 'desc' || field === 'description' || field === 'date' || field === 'quarter' || field === 'formattedDate') {
            return rowData[field];
        }

        // 2) If the value is a string and not a numeric string, return it as-is
        const rawVal = rowData[field];
        if (typeof rawVal === 'string') {
            // Keep percentage strings as-is and any string containing letters
            const hasLetters = /[a-zA-ZğüşöçıİĞÜŞÖÇ]/.test(rawVal);
            if (hasLetters || rawVal.includes('%')) {
                return rawVal;
            }
            // If cleaning typical numeric decorations still leaves a non-number, treat as text
            const cleaned = rawVal.replace(/[\s,%]/g, '');
            if (cleaned === '' || isNaN(Number(cleaned))) {
                return rawVal;
            }
        }

        if (field === 'indexWeight') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'percentage') {
            // return customPercentageFormatter;
        }
        else if (field === 'ask') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'dailyChangePrice') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'dailyVolume') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'expectedDividend') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'dividendYieldTTM') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'twoYearAverageDividendYield') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'threeYearAverageDividendYield') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'pddd') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'fk') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'ybgYield') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'yearlyYield') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'dividendCalendarPaymentDate') {
            return rowData[field];
        }
        else if (field === 'eps') {
            if (rowData['eps'] == "") {
                return ''
            }
            else {
                return numberFormatter.Double(rowData[field], 2);
            }
        }
        else if (field === 'EPSForecast') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === 'Surprise') {
            if (rowData['Surprise'] == "") {
                return ''
            }
            else {
                return numberFormatter.Double(rowData[field], 2);
            }
        }
        else if (field === 'PercentOwnership') {

            if (rowData[field] == 100) {
                return numberFormatter.Double(rowData[field], 0);
            }
            else {
                return numberFormatter.Double(rowData[field], 2);
            }
        }
        else if (field === 'Percent') {

            if (rowData[field] == 100) {
                return numberFormatter.Double(rowData[field], 0);
            }
            else {
                return numberFormatter.Double(rowData[field], 2);
            }
        }
        else if (field === 'Analist Sayısı' || field === 'Analyst Count') {
            return numberFormatter.Double(rowData[field], 0);
        }
        else if ((field.includes('Analist' || field.includes('Analyst'))) && !field.includes('(%) (TR)')) {
            return numberFormatter.Double(rowData[field], 0);
        }
        else if (field === ('Market Capitalization (mn.)') || field === ('Piyasa Değeri (mn.)')) {
            return numberFormatter.Double(rowData[field], 0);
        }
        else if (field === '5') {
            return numberFormatter.Double(rowData[field], 2);
        }
        else if (field === '562') {
            return numberFormatter.Double(rowData[field], 0);
        }
        else if (field === 'quarter') {
            return rowData[field];
        }
        else if (field === 'formattedDate') {
            return rowData[field];
        }



        else if (format && format == 'sb') {
            return ScoreBallFormatter(rowData, field);
        }
        else {
            return numberFormatter.Double(rowData[field], 2);
        }
    };

    const determineFormatter = (field) => {

        if (field === 'indexWeight') {
            return customFormatter;
        } else if (field === 'percentage') {
            // return customPercentageFormatter;
        }
        else {
            return field; // Farklı bir sütun tipi ise null dönebilirsiniz.
        }
    };

    const ScoreBallFormatter = (rowData, field) => {
        return (
            <div className='scoreBall'>
                <div className='scoreBallInner' style={{ backgroundColor: score2color(rowData[field]) }}>
                    <div className='scoreBallInnerText'>
                    </div>
                </div>
            </div>
        )
    }


    function filterMonths(months) {
        // Mevcut ayı bul
        const currentMonth = new Date().getMonth() + 1; // JavaScript'te ay 0'dan başladığı için +1 ekliyoruz

        // İçinde bulunduğumuz ay ve sonrasını içeren ayları filtrele
        const filteredMonths = months.filter(month => month.id >= currentMonth);

        return filteredMonths;
    }

    const dividendCalendarPaymentDateHeaderTemplate = (data) => {
        const months = [
            { code: "January", name: t('date.months.january'), id: 1 },
            { code: "February", name: t('date.months.february'), id: 2 },
            { code: "March", name: t('date.months.march'), id: 3 },
            { code: "April", name: t('date.months.april'), id: 4 },
            { code: "May", name: t('date.months.may'), id: 5 },
            { code: "June", name: t('date.months.june'), id: 6 },
            { code: "July", name: t('date.months.july'), id: 7 },
            { code: "August", name: t('date.months.august'), id: 8 },
            { code: "September", name: t('date.months.september'), id: 9 },
            { code: "October", name: t('date.months.october'), id: 10 },
            { code: "November", name: t('date.months.november'), id: 11 },
            { code: "December", name: t('date.months.december'), id: 12 },
        ]

        const filteredMonths = filterMonths(months);
        filteredMonths.unshift({ code: "All", name: t('allMonthsTable'), id: 0 });

        try {
            return (
                <>
                    <div className="flex align-items-center gap-2">
                        <DropdownPicker
                            className=''
                            listData={filteredMonths}
                            selectedListItem={props.dividendCalendarSelectedMonth}
                            onListItemChange={(event) => props.dividendCalendarChangeMonth(event)}
                            optionLabel='name'
                            icon={true}
                        />

                    </div>
                </>
            )
        } catch (error) {
            console.log('dividendCalendarPaymentDateHeaderTemplate error: ', error);
        }
    }

    const dividendCalendarPaymentDateBodyTemplate = (data) => {

        try {
            return (
                <>
                    <div className='roboto-medium-14'>
                        {data.dividendCalendarPaymentDate}
                    </div>
                </>
            )
        } catch (error) {
            console.log('dividendCalendarPaymentDateBodyTemplate error: ', error);
        }
    }

    const paymentDateTimeBodyTemplate = (data) => {
        try {

            if (data.paymentDateTime == null) {
                return (
                    <>
                        <div className='roboto-medium-14'>
                            {data.paymentDateTime}
                        </div>
                    </>
                )
            }
            else {
                return (
                    <>
                        <div className='roboto-medium-14'>
                            {moment(data.paymentDateTime).locale('tr').format('DD MMMM')}

                        </div>
                    </>
                )
            }

        } catch (error) {
            console.log('paymentDateTimeBodyTemplate error: ', error);
        }
    }

    const paymentDateBodyTemplate = (data) => {
        try {


            if (data.paymentDate == null) {
                return (
                    <>
                        <div className='roboto-medium-14'>
                            {data.paymentDate}
                        </div>
                    </>
                )
            }
            else {
                return (
                    <>
                        <div className='roboto-medium-14'>
                            {moment(data.paymentDate).locale('tr').format('DD.MM.YYYY')}
                        </div>
                    </>
                )
            }
        } catch (error) {
            console.log('paymentDateBodyTemplate error: ', error);
        }
    }


    const searchHeaderBodyTemplate = (format, header) => {

        return (
            <>
                {format && format.indexOf('-s') > -1 ?
                    <div className='absolute-search'>
                        <div className='search-input'>
                            <span className="p-input-icon-left">
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText v-model="value1" placeholder={t('seachSymbol')} onChange={(e) => onGlobalFilterChange(e)} />
                                </IconField>
                            </span>
                        </div>


                    </div>
                    : header}
            </>
        )
    }

    const searchableBodyTemplate = (data, field, format, align) => {

        if (format && format == 'code-s-f') {
            return (
                <div className={`searcable-column-items-code-s-f justify-content-${align == "left" ? 'start' : align == "right" ? 'end' : 'between'}`} style={format.indexOf('-t') == -1 ? { gap: '15px' } : {}}>
                    {format && format.indexOf('-f') > -1 ? <WatchlistAddModal data={data} /> : null}
                    {format && format.indexOf('code') > -1 ? <div className='roboto-medium-14 tickerCode' onClick={(event) => { goToSymbol(data, "codeBodyTemplate") }}>{data.code} </div> : null}
                    {format && format.indexOf('-t') > -1 ? <div className='roboto-medium-14 taBg'> <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => clickGoTechnicalAnalysisPage(data)} /> </div> : null}
                </div>
            )
        }
        else {
            return (
                <div className={`searcable-column-items justify-content-${align == "left" ? 'start' : align == "right" ? 'end' : 'between'}`} >
                    {format && format.indexOf('-f') > -1 ? <WatchlistAddModal data={data} /> : null}
                    {format && format.indexOf('-i') > -1 ?
                        <div className='roboto-medium-14'>
                            <span className='cell-sec-noi'>
                                {data.numberOfInstallments !== undefined
                                    ? data.numberOfInstallments
                                    : data.installement !== undefined
                                        ? data.installement
                                        : '-'}
                            </span>
                        </div>
                        : null}
                    {format && format.indexOf('code') > -1 ? <div className='roboto-medium-14 tickerCode' onClick={(event) => { goToSymbol(data, "codeBodyTemplate") }}>{data.code} </div> : null}
                    {format && format.indexOf('symbolName') > -1 ? <div className='roboto-medium-14 tickerName' onClick={(event) => { goToSymbol(data, "symbolNameBodyTemplate") }}>{data.name} </div> : null}
                    {format && format.indexOf('name') > -1 ? <div className='roboto-medium-14 tickerName' onClick={(event) => { goToSymbol(data, "symbolNameBodyTemplate") }}>{data.name} </div> : null}
                    {format && format.indexOf('-t') > -1 ? <div className='roboto-medium-14 taBg m-l-auto'> <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => clickGoTechnicalAnalysisPage(data)} /> </div> : null}
                    {format && format.indexOf('-m') > -1 ? <div className='roboto-medium-14 taBg  m-l-auto'> <FontAwesomeIcon className='technicalAnalysisIcon' icon={faChartLine} onClick={() => props.openDividendGrapshModal(data)} /> </div> : null}
                </div>
            )
        }

    }

    // Add this new function after searchableBodyTemplate function
    const multiitemHeaderTemplate = (data, field, format, align) => {
        return (
            <div className={`multi-item-header justify-content-${align === "left" ? 'start' : align === "right" ? 'end' : 'between'}`}>
                <div className="multi-item-icon-group">
                    {format && format.indexOf('f') > -1 ?
                        <div className="multi-item-favorite">
                            <WatchlistAddModal data={data} />
                        </div> : null}
                    {format && format.indexOf('c') > -1 ?
                        <div className='multi-item-code roboto-medium-14 tickerCode' onClick={(event) => { goToSymbol(data, "codeBodyTemplate") }}>
                            {data.code}
                        </div> : null}

                    {format && format.indexOf('t') > -1 ?
                        <div className='multi-item-tech'>
                            <div className='roboto-medium-14 taBg'>
                                <FontAwesomeIcon
                                    className='technicalAnalysisIcon'
                                    icon={faChartLine}
                                    onClick={() => clickGoTechnicalAnalysisPage(data)}
                                />
                            </div>
                        </div> : null}
                </div>


            </div>
        )
    };

    const consResearchBodyTemplate = (rowData) => {
        return <ConsensusResearchComponent value={rowData.consResearch} />;
    };

    const technicalAnalysisColoredBodyTemplate = (rowData, field) => {

        return <TechnicalAnalysisColoredBodyComponent value={rowData[field]} />;
    };


    //#endregion BODY TEMPLATE


    const dateSorter = (e) => {

        const field = e.field;
        const order = e.order;
        return e.data.sort((a, b) => {
            const valA = a[field];
            const valB = b[field];
            if (valA == null && valB != null) return 1;
            if (valA != null && valB == null) return -1;
            if (valA == null && valB == null) return 0;
            const timeA = new Date(valA).getTime();
            const timeB = new Date(valB).getTime();
            if (isNaN(timeA) && !isNaN(timeB)) return 1;
            if (!isNaN(timeA) && isNaN(timeB)) return -1;
            return order * (timeA - timeB);
        });
    };

    //#region DYANMIC COLUMNS
    const cellClassName = (data) => (data.change < 0 ? 'realTimeRedBg' : 'realTimeGreenBg');

    // const cellDailyChange = (data) => (data.cellDailyChange < 0 ? 'realTimeRedBg' : 'realTimeGreenBg');

    const cellDailyChange = (data) => {

        if (data.dailyChangeColor == 'green') {
            return 'realTimeGreenBg';
        }
        else if (data.dailyChangeColor == 'red') {
            return 'realTimeRedBg';
        }
        else if (data.dailyChangeColor == 'grey') {
            return 'realTimeGreyBg';
        }
    }

    const cellRocChange = (data, period) => {

        let name = period;

        if (data[period] > 0) {
            return 'realTimeGreenBg';
        }
        else if (data[period] < 0) {
            return 'realTimeRedBg';
        }
        else {
            return 'realTimeGreyBg';
        }
    }

    const sortNumber = (e) => {
        const field = e.field;
        const order = e.order;
        return e.data.sort((a, b) => {
            const val1 = a[field];
            const val2 = b[field];
            if (val1 == null && val2 != null) return 1;
            if (val1 != null && val2 == null) return -1;
            if (val1 == null && val2 == null) return 0;
            const num1 = parseFloat(String(val1).replace(/%/g, ''));
            const num2 = parseFloat(String(val2).replace(/%/g, ''));
            return order * (num1 - num2);
        });
    };

    const customSortFunction = (e) => {

        const field = e.field;
        const order = e.order;
        return e.data.sort((a, b) => {
            const val1 = a[field];
            const val2 = b[field];
            if (val1 == null && val2 != null) return 1;
            if (val1 != null && val2 == null) return -1;
            if (val1 == null && val2 == null) return 0;
            const num1 = parseFloat(String(val1).replace(/%/g, ''));
            const num2 = parseFloat(String(val2).replace(/%/g, ''));
            if (isNaN(num1) && !isNaN(num2)) return 1;
            if (!isNaN(num1) && isNaN(num2)) return -1;
            if (isNaN(num1) && isNaN(num2)) return 0;
            return order * (num1 - num2);
        });
    };


    const searchableHeaderColumnsSorter = (e) => {
        const order = e.order;
        return e.data.sort((a, b) => {
            const val1 = a.code;
            const val2 = b.code;
            if (val1 == null && val2 != null) return 1;
            if (val1 != null && val2 == null) return -1;
            if (val1 == null && val2 == null) return 0;
            return order * val1.localeCompare(val2, 'tr-TR');
        });
    };


    const dynamicColumns = visibleColumns?.map((col, i) => {
        const colKey = col.id + col.field;

        const headerStyle = {
            textAlign: col.headerAlign ? col.headerAlign : (col.align ? col.align : 'center'),
            whiteSpace: col.titleWrap ? 'normal' : '',
            // Apply padding with priority for headerPaddingLeft
            // padding: '0.5rem 0.25rem',
            paddingLeft: col.headerPaddingLeft,
            paddingRight: col.paddingRight || '0.25rem',
            lineHeight: '1.2em',
            height: 'auto'
        };

        const columnProps = {
            columnKey: colKey,
            headerStyle,
            style: {
                width: col.width ? col.width : '1%',
                paddingLeft: col.paddingLeft ? col.paddingLeft : "",
                paddingRight: col.paddingRight ? col.paddingRight : "",
                textAlign: col.align ? col.align : 'right'
            },
            className: 'DataTableColumn',
            field: col.field,
            header: col.header,
            frozen: col.isFrozen ? true : false,
        };

        switch (col.field) {
            case 'fav':
                return <Column key={colKey} {...columnProps} frozen body={(data) => favBodyTemplate(data, 'favModal')} />;
            case 'searchableHeader':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={searchableHeaderColumnsSorter} filterField={col.filterField} frozen={col.isFrozen ? true : false} body={(data) => searchableBodyTemplate(data, 'searchableHeader', col.format, col.align)} header={searchHeaderBodyTemplate(col.format, col.header)} filterMatchMode="customContains" />;
            case 'multiitemHeader':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={searchableHeaderColumnsSorter} filterField={col.filterField} frozen={col.isFrozen ? true : false} body={(data) => multiitemHeaderTemplate(data, 'multiitemHeader', col.format, col.align)} header={col.header} filterMatchMode="customContains" />;
            case 'favWatchlist':
                return <Column key={colKey} {...columnProps} frozen body={(data) => favBodyTemplate(data, 'favWatchlist')} />;
            case 'tickerCode':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} frozen={col.isFrozen ? true : false} body={(data) => { tickerCodeBodyTemplate(data) }} filterField="code" filterMatchMode="customContains" />;
            case 'tickerName':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} frozen={col.isFrozen ? true : false} body='' filterField="tickerName" filterMatchMode="customContains" />;
            case 'name':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} frozen={col.isFrozen ? true : false} body={(data) => nameBodyTemplate(data, col)} filterField="name" filterMatchMode="customContains" />;
            case 'code':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} frozen={col.isFrozen ? true : false} body={(data) => codeBodyTemplate(data, col)} filterField="code" filterMatchMode="customContains" />;
            case 'symbolName':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} body={symbolNameBodyTemplate} />;
            case 'dividendYield':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} body={dividendYieldBodyTemplate} header={(data) => dividendYieldHeaderTemplate(data, col)} />;
            case 'technicalAnalysis':
                return <Column key={colKey} {...columnProps} body={technicalAnalysisBodyTemplate} />;
            case 'dividendExpectChart':
                return <Column key={colKey} {...columnProps} body={dividendExpectChartBodyTemplate} />;
            case 'indicators':
                return <Column key={colKey} {...columnProps} body={(data) => IndicatorsBodyTemplate(data)} />;
            case 'change':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' bodyClassName={cellClassName} body={changeBodyTemplate} />;
            case 'dailyChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' bodyClassName={cellDailyChange} body={dailyChangeBodyTemplate} />;
            case 'rocDailyChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocDaily')} body={(data) => rocChangeBodyTemplate(data, 'rocDaily')} />;
            case 'rocWeeklyChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocWeekly')} body={(data) => rocChangeBodyTemplate(data, 'rocWeekly')} />;
            case 'rocMonthlyChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocMonthly')} body={(data) => rocChangeBodyTemplate(data, 'rocMonthly')} />;
            case 'rocYtdChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocYtd')} body={(data) => rocChangeBodyTemplate(data, 'rocYtd')} />;
            case 'rocAnnualyChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocAnnualy')} body={(data) => rocChangeBodyTemplate(data, 'rocAnnualy')} />;
            case 'rocAnnualChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocAnnual')} body={(data) => rocChangeBodyTemplate(data, 'rocAnnual')} />;
            case 'rocBetweenDateChange':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} sortFunction={sortNumber} className='roboto-medium-14' bodyClassName={(data) => cellRocChange(data, 'rocBetweenDate')} body={(data) => rocChangeBodyTemplate(data, 'rocBetweenDate')} />;
            case 'ask':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={(data) => numberBodyTemplate(data, 'ask')} />;
            case 'bid':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={(data) => numberBodyTemplate(data, 'bid')} />;
            case '52W':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' body={week52BodyTemplate} template={week52BodyTemplate} />;
            case 'range52w':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' body={week52BodyTemplate} template={week52BodyTemplate} />;
            case 'lastPrice':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={(data) => numberBodyTemplate(data, 'lastPrice')} />;
            case 'score':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={scoreBodyTemplate} />;
            case 'search':
                return <Column key={colKey} {...columnProps} header={headerBodyTemplate('search')} className='roboto-medium-14' />;
            case 'lastUpdateDate':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' />;
            case 'lastTradeTime':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' />;
            case 'lastUpdateTime':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' />;
            case 'lastDay':
                return <Column key={colKey} {...columnProps} className='roboto-medium-14' />;
            case 'dividendCalendarPaymentDate':
                return <Column key={colKey} {...columnProps} frozen={col.isFrozen ? true : false} className='roboto-medium-14' body={paymentDateTimeBodyTemplate} header={dividendCalendarPaymentDateHeaderTemplate} />;
            case 'paymentDateTime':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={paymentDateTimeBodyTemplate} />;
            case 'paymentDate':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={paymentDateBodyTemplate} sortFunction={dateSorter} />;
            case 'consResearch':
                return <Column key={colKey} {...columnProps} sortable={col.sortable == undefined ? true : false || !col.sortable ? false : true} className='roboto-medium-14' body={consResearchBodyTemplate} />;
            default:
                return <Column key={colKey} {...columnProps} sortable={col.sortable == true ? true : false} sortFunction={customSortFunction} body={(rowData) => customFormatter(rowData, col.field, col.format)} />;
        }
    });



    //#endregion DYANMIC COLUMNS

    //#region COLUMN SELECT

    const openColumnsSelectContainer = () => {
        try {
            // console.log('openColumnsSelectContainer');
            setVisibleColumnSelect(!visibleColumnSelect);
        } catch (error) {
            // console.log('openColumnsSelectContainer error: ', error);
        }
    }

    const onClickAddColumnItem = (item) => {
        try {
            // console.log('onClickAddColumnItem : ', item);
            if (count < 12) {
                item.isVisible = true;
                setColumns(columns)
                setVisibleColumns(props.columnsProp.filter(col => col.isVisible === true));
                setCount(props.columnsProp.filter(col => col.isVisible === true).length);
            }
            else {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('dataTable.columnLimit') });
                return;
            }

        } catch (error) {
            // console.log('onClickAddColumnItem error: ', error);
        }
    }

    const onClickRemoveColumnItem = (item) => {
        try {
            // console.log('onClickRemoveColumnItem : ', item);
            if (count <= 12) {
                item.isVisible = false;
                setColumns(columns)
                setVisibleColumns(props.columnsProp.filter(col => col.isVisible === true));
                setCount(props.columnsProp.filter(col => col.isVisible === true).length);
            }
            else {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('dataTable.columnLimit') });
                return;
            }

        } catch (error) {
            // console.log('onClickRemoveColumnItem error: ', error);
        }
    }

    //#endregion COLUMN SELECT

    //#region  EXCEL EXPORT
    const filterRowForExcel = (row) => {
        if (props.excelExportFields && props.excelExportFields.length > 0) {
            const filteredRow = {};
            props.excelExportFields.forEach((field) => {
                filteredRow[field] = row[field];
            });
            return filteredRow; //excel'de olmas?? istenilenler
        }
        if (props.excelExcludeFields && props.excelExcludeFields.length > 0) {
            const filteredRow = {};
            Object.keys(row).forEach((key) => {
                if (!props.excelExcludeFields.includes(key)) {
                    filteredRow[key] = row[key];
                }
            });
            return filteredRow; //excel'de olmas?? istenmeyenler.
        }
        return row;
    };

    const applyExcelHeaderMap = (row) => {
        if (!props.excelHeaderMap) {
            return row;
        }
        const mappedRow = {};
        Object.keys(row).forEach((key) => {
            const mappedKey = props.excelHeaderMap[key] || key;
            mappedRow[mappedKey] = row[key];
        });
        return mappedRow;
    };

    const exportExcel = () => {
        import('xlsx').then((xlsx) => {
            const dataForExcel = tableData.map((row) => applyExcelHeaderMap(filterRowForExcel(row)));
            const worksheet = xlsx.utils.json_to_sheet(dataForExcel);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: 'xlsx',
                type: 'array'
            });

            saveAsExcelFile(excelBuffer, props.excelExportName);
        });
    };

    const saveAsExcelFile = (buffer, fileName) => {
        import('file-saver').then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                let EXCEL_EXTENSION = '.xlsx';
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };
    //#endregion  EXCEL EXPORT

    const formatNumber = (value, precision) => {

        let returnV = accounting.formatNumber(value, {
            precision: 2,
            thousand: ",",
            decimal: "."
        });
        return returnV;
    }

    const onGlobalFilterChangePublic = (val) => {

        let _filters = { ...filters };

        _filters['global'].value = val;

        setFilters(_filters);
    };

    const normalizeString = (str) => {
        return str.toLocaleLowerCase('tr-TR'); // Türkçe harf duyarlılığı için locale kullanıyoruz
    };


    const sortIcons = (options) => {

        let icon = options.sorted ? (
            options.sortOrder < 0 ? (
                <FontAwesomeIcon key="sort" icon={faSortDown} {...options.sorted = true} className='sort-icon' />
            ) : (
                <FontAwesomeIcon key="sort-up" icon={faSortUp}  {...options.sorted} className='sort-icon' />
            )
        ) : (
            <FontAwesomeIcon key="sort-down" icon={faSort} {...options.sortOrder} className='sort-icon' />
        );
        return icon;
    };

    // Özel boş veri mesajı için bir fonksiyon oluşturalım
    const emptyMessageTemplate = () => {
        return (
            <div className="empty-message-container">
                <FontAwesomeIcon icon={faDatabase} className="empty-message-icon" />
                <div className="empty-message-text">{props?.emptyMessage ? props?.emptyMessage : t('noDataTable')}</div>
            </div>
        );
    };

    return (
        <>
            <div className='p-0 position-relative columnSelect'>

                {visibleSearch &&
                    <Container className='p-b-5 p-t-10' >
                        <Row>
                            <Col md='4' sm='7'>
                                {/* <Search /> */}
                                <div className='search-input'>

                                    <IconField iconPosition="left">
                                        <InputIcon className="pi pi-search"> </InputIcon>
                                        <InputText v-model="value1" placeholder={t('seachSymbolShare')} onChange={(e) => onGlobalFilterChange(e)} />
                                    </IconField>
                                </div>

                            </Col>
                            <Col md='8' sm='5' className='float-right'>
                                {enabledColumnSelectButton &&
                                    <Button className='columnsSelectButton buttonCustom' onClick={() => openColumnsSelectContainer()}>
                                        <FontAwesomeIcon className='text-align-center' icon={faGear} />
                                    </Button>
                                }
                            </Col>
                        </Row>
                    </Container>
                }

                {visibleColumnSelect &&
                    <Container className='columnsSelectContainer '>
                        <Row className='columnsSelectHeaderRow'>
                            <Col md="11" sm='11' className='color-text roboto-medium-14 p-l-20'>{t('editColumns')}</Col>
                            <Col md="1" sm="1" onClick={props.restartColumns}><FontAwesomeIcon className='text-align-right float-right p-r-20' style={{ cursor: 'pointer' }} icon={faArrowRotateRight} /></Col>
                        </Row>

                        <Container className='p-l-10 p-r-10'>
                            <Row>
                                <Col md='6' sm='12'>
                                    <Row>
                                        <Col md="12" sm='12' className='roboto-bold-14 p-b-15'>{t('columnsToAdd')}</Col>
                                    </Row>
                                    {/* Eklenecek Sutünlar */}
                                    <Row className='p-l-10 p-r-10 scolling-row'>
                                        {columns.map(item =>
                                            <>
                                                {!item.isVisible && item.displayName != "" &&
                                                    <Col md='12' sm="12" className='columnsListItem m-b-10 p-l-10 p-r-10' onClick={() => onClickAddColumnItem(item)}>
                                                        <FontAwesomeIcon className='text-align-center float-left listItemIcon' icon={faSquareChevronRight} />
                                                        <span key="{item}" className='p-l-10 roboto-medium-14'>  {item.displayName}</span>
                                                    </Col>
                                                }
                                            </>
                                        )}
                                    </Row>

                                    {/* Eklenecek Sutünlar */}
                                </Col>

                                <Col md='6' sm='12'>
                                    <Row>
                                        <Col md="10" sm='10' className='roboto-bold-14  p-b-15'>{t('columnSelection')} </Col>
                                        <Col md="2" sm='2' className='numberOfSelectedColums roboto-bold-14'>
                                            {count}/12
                                            {/* {columns.length} */}
                                        </Col>
                                    </Row>

                                    {/* Eklenmiş/Kaldırılacak Sutünlar */}
                                    <Row className='p-l-10 p-r-10 scolling-row'>
                                        {columns.map(item =>
                                            <>
                                                {item.isVisible && item.displayName != "" &&
                                                    <Col md='12' className='columnsSelectedListItem m-b-10' onClick={() => onClickRemoveColumnItem(item)}>
                                                        <FontAwesomeIcon className='text-align-center float-left listItemIcon' icon={faSquareCheck} />
                                                        <span className='p-l-10 roboto-medium-14'>    {item.displayName}</span>
                                                        <FontAwesomeIcon style={{ textAlign: 'right', float: 'right' }} className='text-align-right float-right listItemIcon' icon={faGripDotsVertical} />
                                                    </Col>
                                                }
                                            </>
                                        )}
                                    </Row>
                                    {/* Eklenmiş/Kaldırılacak Sutünlar */}
                                </Col>
                            </Row>


                        </Container>
                    </Container>
                }

            </div>

            <div className='dataTablejs '>
                {/* <Toast ref={toast} /> */}
                {props.excelExport &&
                    <div className='excel-export-div' onClick={exportExcel}>
                        <img
                            src={excel}
                            alt="Excel Export"
                            className="excel-export-icon"
                            style={{ width: 24, height: 24, cursor: 'pointer' }}
                        />
                    </div>
                }
                {
                    visibleAbsoluteSearch &&
                    <div className='absolute-search'>
                        {/* <Search /> */}
                        <div className='search-input'>
                            <span className="p-input-icon-left">
                                <IconField iconPosition="left">
                                    <InputIcon className="pi pi-search"> </InputIcon>
                                    <InputText v-model="value1" placeholder={t('seachSymbol')} onChange={(e) => onGlobalFilterChange(e)} />
                                </IconField>
                            </span>
                        </div>
                    </div>
                }

                <DataTable
                    id={'hoveredDataTable'}
                    sortField={props.sortField ? props.sortField : ""}
                    sortOrder={props.sortOrder ? props.sortOrder : 1}
                    sortIcon={sortIcons}
                    // onSort={props.customSort ? (e) => props.onSort(e) : null}
                    value={tableData}
                    scrollable
                    scrollHeight={props.scrollHeight ? props.scrollHeight : '800px'}
                    showGridlines
                    selectionMode="single"
                    selection={selectedItem}
                    onSelectionChange={(e) => setSelectedItem(e.value)}
                    className='DataTableColumn ' style={{ width: 'auto', overflow: 'auto' }}
                    emptyMessage={emptyMessageTemplate}
                    resizableColumns
                    columnResizeMode="expand"
                    filters={filters}
                    onFilter={(e) => setFilters(e.filters)}
                >
                    {dynamicColumns}
                </DataTable>


            </div >

        </>
    )

}

export default DataTableComponent;


